<template lang="pug">

    div

        thumbnails(
            v-bind:file-models="fileModels"
            v-bind:product-file-models="productFileModels"
            v-bind:product-model="productModel"
        )

        dropzone(v-on:uploaded="onUploaded")

</template>

<script>
    import * as R from 'ramda'
    import Dropzone from '@/components/app/Dropzone'
    import Thumbnails from '@/components/products/files/Thumbnails'
    import store from '@/store'

    export default {

        async beforeRouteEnter(to, from, next) {
            const productId = R.prop('id', to.params)

            const [ productFileModels ] = await Promise.all([

                // Produkt-Dateien laden
                store.dispatch('productFiles/loadAllByProductId', { productId }),

                // Produkt laden
                store.dispatch('products/loadOne', { id: productId })

            ])

            // Dateien laden
            await store.dispatch('files/loadAllByProductFileModels', { productFileModels })

            next()
        },

        components: { Dropzone, Thumbnails },

        data() {
            return {
                uploadIsActive: false
            }
        },

        computed: {

            fileModels() {
                return R.compose(

                    // Dateien holen
                    // > [ 1, 2 ]
                    // < [ { id: 1, name: "foo.jpg", { id: 2, name: "bar.png" } ]
                    R.map(store.getters['files/byId']),

                    // IDs auslesen
                    // > [ { id: 1, foo: 2 }, { id: 2, foo: 3 } ]
                    // < [ 1, 2 ]
                    R.map(R.prop('file'))

                )(this.productFileModels)
            },

            productFileModels() {
                return store.getters['productFiles/allByProductId'](this.productId)
            },

            productModel() {
                return store.getters['products/byId'](this.productId)
            },

            productId() {
                return Number(R.prop('id', this.$route.params))
            }

        },

        methods: {

            async onUploaded({ fileModel }) {
                // Produkt-Datei-Model erstellen
                const productFileModel = {
                    file:    fileModel.id,
                    product: this.productId,
                    type:    'PRINTING_DATA'
                }

                try {
                    // Produkt-Datei erstellen
                    await this.$store.dispatch('productFiles/create', { model: productFileModel })

                    // Erfolgsmeldung anzeigen
                    this.$growl.success('Datei wurde gespeichert')

                } catch (e) {
                    this.$growl.fatal('Datei konnte nicht gespeichert werden', e)
                }
            },

        }

    }

</script>

